// Aloha Tequila Fest — Brand Guide data
// Replace placeholder fields marked "Confirm before publishing" with verified
// distillery / NOM / tasting-note copy before going public.
//
// Schema:
//   brand        string  Brand display name (e.g. "Tequila Ocho")
//   slug         string  URL-safe id used for ?brand= query param
//   type         enum    "Tequila" | "Mezcal" | "Sotol"
//   expressions  string[] List of available expressions
//   distillery   string  Distillery / NOM. Mark "Confirm before publishing" if unknown.
//   notes        string  Tasting notes summary. Mark "Confirm before publishing" if unknown.
//   source       enum    "Verified" | "User brand materials; verify before publishing" | "Needs confirmation"

const N = "Confirm before publishing.";

export const BRAND_TYPES = ["All", "Tequila", "Mezcal", "Sotol"];

export const brands = [
  // ───────── Tequila (premium / additive-aware / sponsor-aligned) ─────────
  {
    brand: "Tequila Ocho",
    slug: "tequila-ocho",
    type: "Tequila",
    expressions: ["Plata (Blanco)", "Reposado", "Añejo", "Extra Añejo", "Single-estate annual releases"],
    distillery: "La Alteña Distillery (NOM 1474), Arandas, Jalisco. Carlos Camarena / Tomás Estes family.",
    notes: "Highland agave-driven profile. First brand to bottle by single estate and harvest year. Add official tasting notes per vintage / estate.",
    source: "Needs confirmation"
  },
  {
    brand: "Espolòn",
    slug: "espolon",
    type: "Tequila",
    expressions: ["Blanco", "Reposado", "Añejo", "Cristalino"],
    distillery: "Confirm current distillery / NOM by bottle.",
    notes: "Reposado: roasted agave, tropical fruit, vanilla, warming spice. Añejo: roasted agave, wood, caramel, vanilla, dried fruit.",
    source: "Needs confirmation"
  },
  {
    brand: "Código 1530",
    slug: "codigo-1530",
    type: "Tequila",
    expressions: ["Blanco", "Rosa", "Reposado", "Añejo", "Origen"],
    distillery: N,
    notes: "Additive-free, French Napa Cabernet wine-barrel aged (Rosa, Reposado, Añejo). " + N,
    source: "Needs confirmation"
  },
  {
    brand: "El Tesoro",
    slug: "el-tesoro",
    type: "Tequila",
    expressions: ["Blanco", "Reposado", "Añejo", "Extra Añejo", "Paradiso"],
    distillery: "La Alteña Distillery (NOM 1139), Arandas, Jalisco — Camarena family. Confirm NOM by bottle.",
    notes: "Tahona-crushed highland agave, additive-free. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "Komos",
    slug: "komos",
    type: "Tequila",
    expressions: ["Reposado Rosa", "Añejo Cristalino", "Extra Añejo"],
    distillery: N,
    notes: "Additive-free luxury tequila finished in European wine barrels. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "Don Fulano",
    slug: "don-fulano",
    type: "Tequila",
    expressions: ["Blanco", "Fuerte (Blanco High-Proof)", "Reposado", "Añejo", "Imperial Extra Añejo"],
    distillery: "Tequilas Fabricantes de Tequila (NOM 1146), Atotonilco, Jalisco — Fonseca family. Confirm NOM by bottle.",
    notes: "Estate-grown highland agave, additive-free, European cooperage. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "G4",
    slug: "g4",
    type: "Tequila",
    expressions: ["Blanco", "Blanco High Proof", "Madera", "Reposado", "Añejo", "Extra Añejo"],
    distillery: "Destilería El Pandillo (NOM 1579), Jesús María, Los Altos. Felipe & Carlos Camarena.",
    notes: "Estate-distilled with rainwater + deep-well water blend, additive-free. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "Cuervo Reserva de la Familia",
    slug: "cuervo-reserva-de-la-familia",
    type: "Tequila",
    expressions: ["Platino", "Extra Añejo"],
    distillery: "La Rojeña (NOM 1122), Tequila, Jalisco — Becle / Jose Cuervo.",
    notes: "Annual artist-designed limited bottling. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "Cuervo Tradicional",
    slug: "cuervo-tradicional",
    type: "Tequila",
    expressions: ["Plata (Silver)", "Reposado", "Añejo", "Cristalino"],
    distillery: "La Rojeña (NOM 1122), Tequila, Jalisco — Becle / Jose Cuervo.",
    notes: N,
    source: "Needs confirmation"
  },
  {
    brand: "1800",
    slug: "1800",
    type: "Tequila",
    expressions: ["Silver", "Reposado", "Añejo", "Cristalino", "Coconut", "Milenio"],
    distillery: "La Rojeña (NOM 1122), Jalisco — Becle. Confirm NOM by bottle.",
    notes: N,
    source: "Needs confirmation"
  },
  {
    brand: "Maestro Dobel",
    slug: "maestro-dobel",
    type: "Tequila",
    expressions: ["Diamante (Cristalino)", "Reposado", "Añejo", "Humito"],
    distillery: N,
    notes: "Diamante Cristalino: smooth filtered añejo blend. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "Dobel 50",
    slug: "dobel-50",
    type: "Tequila",
    expressions: ["Extra Añejo Cristalino"],
    distillery: N,
    notes: "Ultra-premium extra añejo aged 6+ years and filtered to crystal-clear. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "Gran Coramino",
    slug: "gran-coramino",
    type: "Tequila",
    expressions: ["Reposado Cristalino", "Añejo"],
    distillery: N,
    notes: "Kevin Hart founded. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "Gran Centenario",
    slug: "gran-centenario",
    type: "Tequila",
    expressions: ["Plata", "Reposado", "Añejo", "Cristalino"],
    distillery: "Becle / Proximo portfolio. Confirm NOM by bottle.",
    notes: N,
    source: "Needs confirmation"
  },
  {
    brand: "Volcán de Mi Tierra",
    slug: "volcan-de-mi-tierra",
    type: "Tequila",
    expressions: ["Blanco", "Reposado", "Cristalino X.A", "Tahona Blanco"],
    distillery: "LVMH-owned. Confirm distillery / NOM by bottle.",
    notes: "Highland + lowland agave blend; X.A Cristalino is a luxury cristalino. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "Kapena",
    slug: "kapena",
    type: "Tequila",
    expressions: ["Blanco", "Reposado", "Añejo", "Li Hing"],
    distillery: N,
    notes: "Hawaii-aligned brand. Li Hing is a Hawaiian flavored expression. " + N,
    source: "User brand materials; verify before publishing"
  },
  {
    brand: "El Jimador",
    slug: "el-jimador",
    type: "Tequila",
    expressions: ["Silver (Blanco)", "Reposado", "Añejo"],
    distillery: "Casa Herradura (NOM 1119), Amatitán, Jalisco — Brown-Forman.",
    notes: N,
    source: "Needs confirmation"
  },
  {
    brand: "Herradura",
    slug: "herradura",
    type: "Tequila",
    expressions: ["Silver (Plata)", "Reposado", "Añejo", "Ultra Añejo", "Legend Añejo", "Selección Suprema"],
    distillery: "Casa Herradura (NOM 1119), Amatitán, Jalisco — Brown-Forman. Estate-grown agave, additive-free.",
    notes: "100% estate-grown blue agave. Long-aged expressions are barrel-forward. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "Angelisco",
    slug: "angelisco",
    type: "Tequila",
    expressions: ["Blanco", "Reposado", "Añejo"],
    distillery: N,
    notes: N,
    source: "Needs confirmation"
  },
  {
    brand: "512 Tequila",
    slug: "512-tequila",
    type: "Tequila",
    expressions: ["Blanco", "Reposado", "Añejo"],
    distillery: "Texas-founded brand. Confirm Mexican distillery / NOM by bottle.",
    notes: N,
    source: "Needs confirmation"
  },
  {
    brand: "Partida",
    slug: "partida",
    type: "Tequila",
    expressions: ["Blanco", "Reposado", "Añejo", "Cristalino"],
    distillery: "Estate-grown highland agave. Confirm NOM by bottle.",
    notes: "Additive-free, estate-grown. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "Partida Roble Fino",
    slug: "partida-roble-fino",
    type: "Tequila",
    expressions: ["Sherry Cask Reposado", "Sherry Cask Añejo", "Sherry Cask Extra Añejo"],
    distillery: "Estate-grown highland agave. Confirm NOM by bottle.",
    notes: "Single-malt-style Scotch / Sherry-cask finished line. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "Paladar",
    slug: "paladar",
    type: "Tequila",
    expressions: ["Blanco", "Reposado", "Añejo"],
    distillery: N,
    notes: N,
    source: "Needs confirmation"
  },
  {
    brand: "Casa Azul",
    slug: "casa-azul",
    type: "Tequila",
    expressions: ["Blanco", "Reposado", "Añejo", "Cristalino"],
    distillery: N,
    notes: "Additive-free, organic-certified. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "La Gritona",
    slug: "la-gritona",
    type: "Tequila",
    expressions: ["Reposado"],
    distillery: "Destiladora Huerta Real (NOM 1533), Valle de Guadalupe, Jalisco. Master distiller Melly Barajas. Confirm by bottle.",
    notes: "Women-led production; single reposado expression aged in ex-bourbon barrels. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "Terralta",
    slug: "terralta",
    type: "Tequila",
    expressions: ["Blanco", "Blanco High Proof", "Reposado", "Añejo"],
    distillery: "Destilería El Ranchito (NOM 1579 family). Confirm by bottle.",
    notes: "Estate-grown highland agave, additive-free. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "Santaleza",
    slug: "santaleza",
    type: "Tequila",
    expressions: ["Blanco", "Reposado", "Añejo"],
    distillery: N,
    notes: N,
    source: "Needs confirmation"
  },
  {
    brand: "Milagro",
    slug: "milagro",
    type: "Tequila",
    expressions: ["Silver", "Reposado", "Añejo"],
    distillery: "William Grant & Sons portfolio. Confirm distillery / NOM by bottle.",
    notes: "Triple-distilled core line. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "Milagro Barrel Select",
    slug: "milagro-barrel-select",
    type: "Tequila",
    expressions: ["Reserve Silver", "Reserve Reposado", "Reserve Añejo"],
    distillery: "William Grant & Sons portfolio. Confirm distillery / NOM by bottle.",
    notes: "Premium Reserve / Barrel Select line. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "Mandala",
    slug: "mandala",
    type: "Tequila",
    expressions: ["Blanco", "Reposado", "Añejo", "Extra Añejo"],
    distillery: N,
    notes: N,
    source: "Needs confirmation"
  },
  {
    brand: "Casa Obsidiana",
    slug: "casa-obsidiana",
    type: "Tequila",
    expressions: ["Blanco", "Reposado", "Añejo"],
    distillery: N,
    notes: N,
    source: "Needs confirmation"
  },
  {
    brand: "3 Tres",
    slug: "3-tres",
    type: "Tequila",
    expressions: ["Blanco", "Reposado", "Añejo", "Extra Añejo"],
    distillery: "NOM 1437 / Casa Don Roberto, based on brand materials. Confirm final bottle labels before publishing.",
    notes: "Additive-free, clean agave, premium sipping profile. " + N,
    source: "User brand materials; verify before publishing"
  },
  {
    brand: "Real del Valle",
    slug: "real-del-valle",
    type: "Tequila",
    expressions: ["Blanco", "Reposado"],
    distillery: N,
    notes: N,
    source: "Needs confirmation"
  },

  // ───────── Mezcal ─────────
  {
    brand: "Xicaru",
    slug: "xicaru",
    type: "Mezcal",
    expressions: ["Silver (Espadín)", "Reposado (Espadín)", "Tobalá", "Pechuga"],
    distillery: "Espadín-led producer from Oaxaca. Confirm exact palenque / NOM by bottle.",
    notes: "Smoky agave, citrus, mineral. " + N,
    source: "Needs confirmation"
  },
  {
    brand: "400 Conejos",
    slug: "400-conejos",
    type: "Mezcal",
    expressions: ["Joven", "Reposado", "Tobaziche", "Tepeztate"],
    distillery: "Casa Cuervo / Becle portfolio. Confirm palenque by bottle.",
    notes: N,
    source: "Needs confirmation"
  },
  {
    brand: "Agave de Cortés",
    slug: "agave-de-cortes",
    type: "Mezcal",
    expressions: ["Joven (Espadín)", "Reposado", "Añejo", "Tobalá"],
    distillery: "Family-produced mezcal from Oaxaca. Confirm palenque by bottle.",
    notes: N,
    source: "Needs confirmation"
  },
  {
    brand: "El Jolgorio",
    slug: "el-jolgorio",
    type: "Mezcal",
    expressions: ["Espadín", "Tobalá", "Madrecuixe", "Tepeztate", "Barril", "Pechuga (limited)"],
    distillery: "Single-village artisanal producers across Oaxaca (Casa Cortés family). Bottlings are single-batch; confirm batch info by bottle.",
    notes: "Wild & cultivated agave varietals, traditional clay or copper pot, batch-bottled. " + N,
    source: "Needs confirmation"
  },

  // ───────── Sotol ─────────
  {
    brand: "Sotol Por Siempre",
    slug: "sotol-por-siempre",
    type: "Sotol",
    expressions: ["Blanco", "Reposado"],
    distillery: "Produced from Dasylirion (sotol plant) — typically Chihuahua, Mexico. Confirm producer by bottle.",
    notes: "Sotol is not agave; it's distilled from Dasylirion. Earthy, herbaceous, mineral. " + N,
    source: "Needs confirmation"
  }
];

export default brands;
